<template>
	<v-menu transition="scale-transition" origin="center center">
		<v-btn class="choose-form-component-button" slot="activator" dark color="primary" v-text="legalFormType.name"/>
		<v-list>
			<v-list-tile v-for="option in legalFormType.options" :key="option" @click="legalFormChosen(option)" aria-label="label for text">
				<v-list-tile-title v-text="option"></v-list-tile-title>
			</v-list-tile>
		</v-list>
	</v-menu>
</template>

<script>
	import {getIdByLegalFormName} from "@/utils/LegalFormDictionary";

	export default {
		name: "ChooseForm",


		methods: {
			legalFormChosen(optionChosen) {
        this.hasKrs = optionChosen === "Fundacja" || optionChosen === "Stowarzyszenie" || optionChosen === "Stowarzyszenie samorządowe"
            || optionChosen === "Stowarzyszenie kultury fizycznej" || optionChosen === "Związek stowarzyszeń";
        this.$root.$emit("krsValueChanged", this.hasKrs);

				this.legalForm.type = this.legalFormType.name;
				this.legalForm.subtype = optionChosen;
				this.legalForm.id = getIdByLegalFormName(optionChosen);

				let formType = this.legalForm.subtype;
				if (formType !== undefined && (formType === this.legalFormType.options[0] || formType === this.legalFormType.options[1])) {
					// TODO
				}
			},
		},

		props: {
			legalForm: Object,
			legalFormType: Object,
		},

		data() {
			return {
				hasKrs: false,
			};
		},
	};
</script>

<style scoped>
	.choose-form-component-button {
		height: 45px;
		width: 300px;
	}

	.application.mediumFont .choose-form-component-button {
		height: 55px !important;
		}

	.application.largeFont .choose-form-component-button {
		height: 65px !important;
	}
</style>
